import { useEffect } from 'react'
import { updateParticipantStatus } from 'services/api/participantStatus'
import LocalStorage from 'services/LocalStorage'
import Logger from 'services/Logger'
import { EventDoc, ParticipantDeliveryStatusType } from 'types/api/changes'
import { Model } from 'types/model'
import { LocalStorageKey } from 'types/services/localStorage'
import { isGroupcalApp } from 'utils/appType'
import { isTrulyEmpty } from 'utils/object'

const pendingReads = new Set<string>()

export function useMarkEventAsRead(event?: Model<EventDoc> | EventDoc) {
  const userId = LocalStorage.get(LocalStorageKey.USER_ID) ?? ''
  const deliveryStatus =
    event?.ParticipantsStatus?.[userId]?.ParticipantDeliveryStatus

  useEffect(() => {
    if (
      !isGroupcalApp() ||
      !event ||
      isTrulyEmpty(event._id) ||
      isTrulyEmpty(event._rev) ||
      !userId ||
      (!isTrulyEmpty(event.local_id) && event.OwnerID === userId) ||
      deliveryStatus === ParticipantDeliveryStatusType.READ
    )
      return

    const key = JSON.stringify([userId, event._id])
    if (pendingReads.has(key)) return
    pendingReads.add(key)
    void updateParticipantStatus([
      {
        _id: event._id,
        ParticipantsStatus: {
          ...event.ParticipantsStatus?.[userId],
          ParticipantDeliveryStatus: ParticipantDeliveryStatusType.READ
        },
        DeviceChangeID: LocalStorage.get(LocalStorageKey.DEVICE_ID) ?? ''
      }
    ])
      .catch((error) => {
        Logger.red('Unable to mark event as read', error)
      })
      .finally(() => {
        pendingReads.delete(key)
      })
  }, [
    event?._id,
    event?._rev,
    event?.local_id,
    event?.OwnerID,
    userId,
    deliveryStatus
  ])
}
